import { types } from 'mobx-state-tree';
import { IcsCampaignV2 } from '@icecreamsocial/mst-models';

export const Campaign = types.snapshotProcessor(IcsCampaignV2, {
	preProcessor(snapshot) {
		return snapshot
			? {
					...snapshot,
					id: `${snapshot.id}`,
			  }
			: undefined;
	},
});
